/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：公共分页组件 
 * 使用说明: 参考 sw-paging 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ElementRef, SimpleChanges } from '@angular/core';
declare var $: any;

/**
 * 公共分页组件  sw-paging
 */
@Component({
  selector: 'sw-paging',
  templateUrl: './sw-paging.component.html',
  styleUrls: ['./sw-paging.component.css']
})
export class SwPagingComponent implements OnInit, AfterViewInit {
  /**
   * 输入分页对象属性 
   *  
   * 当前页：current 1
   * 
   * 总页数：pages 
   * 
   * 每页显示数量 ：size 10
   * 
   * 总数量：total
   * 
   * 输入跳转页面值: toGoValue
   */
  @Input()
  pageBase: any = {}

  /**
   * 分页点击事件 抛出分页对象
   */
  @Output() page = new EventEmitter();

  /**
   * 跳转页码
   * @ignore
   */
  toGoValue: string = ''

  /**
   * 排序对象
   * orderType ''(未排序) asc（升序） desc（降序）
   * orderName 排序字段
   * @ignore
   */
  order: any = {
    orderName: '',
    orderType: ''
  }

  /**
   * 排序的箭头
   */
  ifOrder: boolean = false;

  /**
   * 传出选中的节点数据
   * 选中的排序数据抛出
   */
  @Output() orderData = new EventEmitter<string>();

    /**
   * 表格数据是否排序 （非表头排序） toolbar下拉排序 功能
   */
  @Input() isOrder: boolean = false

   /**
   * defaultOrderBy 下拉排序对应的默认选中值 字符串 格式类型为 't.' + orderName + ' ' + orderType
   * 业务端传入
   * t.role_name asc
   */
  @Input() defaultOrderBy:string = ""

  aginDefaultOrderBy: string = ''; // 当isOrder为true时 为下拉排序功能  在点击表头排序 或者 点击下拉排序功能时 渲染表格表头箭头后 需要对该变量赋值 使其值和抛出的defaultOrderBy值相同 防止二次抛出，无限循环调用列表接口问题
  /**
   * @ignore
   */
  constructor(private ele :ElementRef) { }
  /**
    * @ignore
    */
  ngOnInit() { 
  }
  /**
  * @ignore
  */
  ngOnChanges(changes: SimpleChanges): void {
    //判断当当前页面大于总页面时，当前页面等于总页面
    if (Object.keys(this.pageBase).length > 0) {
      if (this.pageBase.current > this.pageBase.pages && this.pageBase.total != 0) {
        this.pageBase.current = this.pageBase.pages;
        this.page.emit(this.pageBase)
      }
    }else if(Object.keys(this.pageBase).length == 0){
      //判断当前页面为重置时 表头排序清除
      let id = this.ele.nativeElement.parentElement.parentElement.id
      if(id){
        for (let j = 0; j < $("#"+id+" .sort-title").length; j++) {
          $("#"+id+" .sort-title").eq(j).find('.fa-caret-up').remove();
          $("#"+id+" .sort-title").eq(j).find('.fa-caret-down').remove();
         }
      }
    }
    //检测当为下拉排序功能时 获取数据
    if(changes && changes['defaultOrderBy']) {
      //如果为下拉排序功能（非点击表格表头排序）
      if(this.isOrder && this.defaultOrderBy != this.aginDefaultOrderBy){
        //匹配对应的要排序的表格表头 添加箭头功能
        setTimeout(()=>{
          let ids = this.ele.nativeElement.parentElement.parentElement.id
          if(ids){
            //根据输入值defaultOrderBy 获取对应的表格表头可以排序的属性columnname 和升序降序类型 
            let name = this.defaultOrderBy.split(" ")[0].split(".")[1]
            let type = this.defaultOrderBy.split(" ")[1]
            //根据表格ids 循环其可以点击排序类sort-title  查找是否有columnname等于name  若有则获取对应的下标 若没有 则表示该表格对应的列不排序或不存在 
            for (let j = 0; j < $("#"+ids+" .sort-title").length; j++) {
              let index = j;
               //获取当前表头的columnname属性值
              let content = $("#"+ids+" .sort-title").eq(index).attr('columnname')
              if(content == name){
                this.fetchTableTitle(name, index, ids,type)
                this.page.emit(this.pageBase)
              }
            }
          }
        },0)
      }
      
    
    }
   
  
  }
  /**
    * @ignore
    */
  ngAfterViewInit() {
    let that = this;
    let id = this.ele.nativeElement.parentElement.parentElement.id
    if(id) {
      for (let j = 0; j < $("#"+id+" .sort-title").length; j++) {
        let index = j;
        //添加默认排序图标 2021-12-10
        $("#"+id+" .sort-title").eq(index).find('i').remove();
        $("#"+id+" .sort-title").eq(index).append('<i class="icon iconfont iconbtn_paixu sort" style="color:#cccccc;"></i>')
        //点击要排序的表头
        $("#"+id+" .sort-title").eq(j).click(function () {
          //要排序的表头箭头清空
          for (let i = 0; i < $("#"+id+" .sort-title").length; i++) {
            $("#"+id+" .sort-title").eq(i).find('i').remove();
            //增加排序默认图标 2021-12-10
            if(i != index){
              $("#"+id+" .sort-title").eq(i).append('<i class="icon iconfont iconbtn_paixu sort" style="color:#cccccc;"></i>')
            }
          }
          //获取点击的当前表头的columnname属性值
          let content = $("#"+id+" .sort-title").eq(index).attr('columnname')
          that.clickTableTitle(content, index, id)
          that.page.emit(that.pageBase)
          //that.orderData.emit(that.order)
        })
      }
    }
  }

  /**
   * 点击表头 箭头切换
   * @ignore
   */
  clickTableTitle(orderName: string, index: number, id:string) {
    this.order.orderType = '';
    if (this.order.orderName == orderName) { 
      //
      if (!this.ifOrder) {
        //升序
        this.order.orderType = 'asc';
        this.ifOrder = !this.ifOrder;
        $("#"+id+" .sort-title").eq(index).append('<i class="icon iconfont iconbtn_ascend sort"></i>')
      } else {
        //降序
        this.order.orderType = 'desc';
        this.ifOrder = !this.ifOrder;
        $("#"+id+" .sort-title").eq(index).append('<i class="icon iconfont iconbtn_descend sort"></i>')
      }
    } else {
      //第一次点击表头 或 当前点击的表头和之前的表头不一样
      this.order.orderName = orderName;
      this.order.orderType = 'asc';
      this.ifOrder = true;
      $("#"+id+" .sort-title").eq(index).append('<i class="icon iconfont iconbtn_ascend sort"></i>')
    }
    this.pageBase.orderBy = 't.' + this.order.orderName + ' ' + this.order.orderType;
    this.aginDefaultOrderBy = 't.' + this.order.orderName + ' ' + this.order.orderType;
  }

  /**
   * 根据defaultOrderBy值 匹配书记 箭头切换 （下拉列表排序）
   * @ignore
   */
  fetchTableTitle(orderName: string, index: number, id:string,ordertype: string)  {
    for (let i = 0; i < $("#"+id+" .sort-title").length; i++) {
      $("#"+id+" .sort-title").eq(i).find('i').remove();
      //增加排序默认图标 2021-12-10
      if(i != index){
        $("#"+id+" .sort-title").eq(i).append('<i class="icon iconfont iconbtn_paixu sort" style="color:#cccccc;"></i>')
      }
    }
    //升序
    if(ordertype == 'asc'){
      this.order.orderName = orderName;
      this.order.orderType = 'asc';
      this.ifOrder = true;
      $("#"+id+" .sort-title").eq(index).append('<i class="icon iconfont iconbtn_ascend sort"></i>')
    }else if(ordertype == 'desc'){
      //降序
      this.order.orderName = orderName;
      this.order.orderType = 'desc';
      this.ifOrder = false;
      $("#"+id+" .sort-title").eq(index).append('<i class="icon iconfont iconbtn_descend sort"></i>')
    } 
    this.pageBase.orderBy = 't.' + this.order.orderName + ' ' + this.order.orderType;
    this.aginDefaultOrderBy = 't.' + this.order.orderName + ' ' + this.order.orderType;
  }
  /**
   * @ignore
   */
  arr = Array;

  /**
   * 点击上一页下一页
   * @param current  分页页码
   * @ignore
   */
  clickPage(current: number) {
    if (current <= 0) return;
    if (current > this.pageBase.pages) return;
    this.pageBase.current = current;
    this.page.emit(this.pageBase)
  }

  /**
   * 选中每页显示数量
   * @param size  显示数量
   * @ignore 
   */
  clickPageNumber(size: number) {
    this.pageBase.size = size;
    this.pageBase.current = 1;
    this.page.emit(this.pageBase)
  }

  /**
   * 点击跳转
   * @param current  跳转页码
   * @ignore
   */
  clickToGoPage(current) {
    //跳转到指定页码
    let reg = /^[1-9]\d*$/;
    //输入页面小于0或者异常的时候 默认为1
    if (current <= 0 || current == '' || !reg.test(current)) {
      this.pageBase.current = 1;
      //判断当前页码和输入页码
    } else if (current > this.pageBase.pages) {
      this.pageBase.current = this.pageBase.pages;
    } else {
      //将输入的页码赋予当前页码
      this.pageBase.current = current;
    }
    this.toGoValue = '';
    //抛出当前页码
    this.page.emit(this.pageBase)
  }

  /**
   * keyup和change事件 判断输入的值是否为大于0的纯数字字符串
   * @param value  校验输入的页码
   * @ignore
   */
  searchValue(value) {
    let reg = /^[1-9]\d*$/;
    if (!reg.test(value)) {
      this.toGoValue = ''
    }
  }


}
